import { __assign } from "tslib";
// DS: CR17, CMPST05
import React from 'react';
import classnames from 'classnames';
import Content from './_partials/Content';
import PanelC33C from './_partials/PanelC33C';
import { getDeviationType } from '../../_helpers';
import { DeviationTypes } from '../../../types/deviation';
import ErrorBoundary from '../../../ErrorBoundary';
import s from './ShopThumb.scss';
export var PANEL_HEIGHT = 82;
export var DEFAULT_THUMB_HEIGHT = 337;
var ShopThumb = function (_a) {
    var deviation = _a.deviation, price = _a.price, priceLabel = _a.priceLabel, priceLabelOnTop = _a.priceLabelOnTop, showAuthor = _a.showAuthor, width = _a.width, height = _a.height, disabled = _a.disabled, disabledLabel = _a.disabledLabel, style = _a.style, textContent = _a.textContent, dollarsCost = _a.dollarsCost, _b = _a.addLink, addLink = _b === void 0 ? true : _b;
    var effectiveHeight = height || DEFAULT_THUMB_HEIGHT + PANEL_HEIGHT;
    var isCommission = getDeviationType(deviation) === DeviationTypes.COMMISSION;
    return (React.createElement("div", { className: classnames(s['root'], disabled && s['disabled']), style: __assign({ width: width, height: effectiveHeight }, style) },
        React.createElement(ErrorBoundary, { debugComponent: "ShopThumb" },
            React.createElement(Content, { deviation: deviation, textContent: textContent, width: width, height: effectiveHeight - PANEL_HEIGHT, disabled: disabled, disabledLabel: disabledLabel }),
            React.createElement(PanelC33C, { deviation: deviation, price: price, priceTextClassName: s['footer-price'], priceLabel: priceLabel, priceLabelOnTop: priceLabelOnTop, showAuthor: showAuthor, showTimestamp: !isCommission, dollarsCost: dollarsCost, addLink: addLink }))));
};
ShopThumb.displayName = 'ShopThumb';
ShopThumb.defaultProps = {
    priceLabel: 'shop.thumb.points',
    priceLabelOnTop: false,
    showAuthor: true,
};
export default ShopThumb;
//# sourceMappingURL=ShopThumb.js.map